function filterProducts() {
	var input, filter, productGrid, products, product, i, txtValue, visibleCount = 0;
	input = document.getElementById('collection-search');
	filter = input.value.toLowerCase();
	productGrid = document.querySelector('.collection .grid');
	products = productGrid.getElementsByClassName('grid__item');
	var totalProductCount = products.length;
	
	for (i = 0; i < products.length; i++) {
		product = products[i];
		txtValue = product.textContent || product.innerText;
		if (txtValue.toLowerCase().indexOf(filter) > -1) {
			product.style.display = "block"; // Ensure the product remains in the grid
			product.style.visibility = "visible";
			product.style.opacity = "1";
			visibleCount++;
		} else {
			product.style.display = "none"; // Keep the grid intact
			product.style.visibility = "hidden"; // Hide the product
			product.style.opacity = "0";
		}
	}
	
	// Update the product count
	document.getElementById('product-count').textContent = `(${visibleCount})`;
	
	// Display custom "No products found" message if no products are visible
	var notProductDiv = document.querySelector('#product-not-fount');
	var notProductText = document.querySelector('#product-not-fount h3 span');
	if (visibleCount === 0) {
		notProductText.innerHTML = `No results found for <span class="search-word">“${input.value}”</span>. Check the spelling or use a different word or phrase.`;
		notProductDiv.style.display = "block";
	} else {
		notProductDiv.style.display = "none";
	}
}
function filterBlogs() {
	var input, filter, productGrid, products, product, i, txtValue, visibleCount = 0;
	input = document.getElementById('blog-search');
	filter = input.value.toLowerCase();
	productGrid = document.querySelector('.blog-articles');
	products = productGrid.getElementsByClassName('blog-articles__article');
	var totalProductCount = products.length;
	
	for (i = 0; i < products.length; i++) {
		product = products[i];
		txtValue = product.textContent || product.innerText;
		if (txtValue.toLowerCase().indexOf(filter) > -1) {
			product.style.display = "block"; // Ensure the product remains in the grid
			product.style.visibility = "visible";
			product.style.opacity = "1";
			visibleCount++;
			// Update the product count
			document.getElementById('blog-count').textContent = `(${visibleCount})`;
		} else {
			product.style.display = "none"; // Keep the grid intact
			product.style.visibility = "hidden"; // Hide the product
			product.style.opacity = "0";
		}
	}
	if (filter == '') {
		const getCount = document.getElementById('blog-count');
		getCount.textContent = `(${getCount.getAttribute("blogs")})`;
	}
	// Display custom "No products found" message if no products are visible
	var notProductDiv = document.querySelector('#product-not-fount');
	var notProductText = document.querySelector('#product-not-fount h3 span');
	if (visibleCount === 0) {
		notProductText.innerHTML = `No results found for <span class="search-word">“${input.value}”</span>. Check the spelling or use a different word or phrase.`;
		notProductDiv.style.display = "block";
	} else {
		notProductDiv.style.display = "none";
	}
}